import React, {
  useState,
  useEffect,
  Suspense,
  lazy,
  useRef,
  useMemo,
  useCallback,
} from "react";
import "../../css/rankTracking.css";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Spinner from "../../share/components/spinner";
import { ScrollToView } from "../../share/helper-js/scroll-into-view";
// icons
import DeleteIcon from "@mui/icons-material/Delete";
import { ZustandStore } from "../../../store/zustand-store.js";
import useQuery from "../../share/custom-hook/useQuery";
import countryList from "../../dataFiles/country";
import BusinessListDropdown from "./BusinessListDropdown.jsx";
import BusinessLocation from "./BusinessLocation.jsx";
import MapLastUpdate from "./MapLastUpdate.jsx";
import AreYousure from "../../share/card-layout/AreYousure.jsx";
import axios from "axios";
import { MAPdelete_Project } from "../../../services/constants.jsx";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import { isDateDiffDaysOld } from "../../../helperJs/helper.js";
import ProjectSetting from "./ProjectSetting.jsx";
import FallbackLoader from "../../share/components/FallbackLoader.jsx";
import SemButton from "../../../common/components/Button.jsx";
import AddProject from "../../share/components/add-project-section/map-tracker/AddProject.jsx";
import { useTranslation } from "react-i18next";
import { ReactComponent as RankIcon } from "../../Assets/home/keyword-rank-icon.svg";

const MapAverageRank = lazy(() =>
  import("../../share/charts/MapRankChart.jsx")
);
const CopyLinkDialog = lazy(() =>
  import("../../../Layout/GuestLink/component/CopyLinkDialog.jsx")
);
const MapRankTable = lazy(() => import("./MapRankTable.jsx"));
const RankTrackingSerStop = lazy(() =>
  import("../../share/components/dialog/rankTrackingSerStop.jsx")
);

const MapTracking = () => {
  const location_path = useLocation();
  const {
    improved,
    declined,
    RANKKEYWORD,
    map_keyword_old_data,
    map_keyword_latest_data,
    mapshowloader,
    SELECTEDPROJECTNEWDATA,
    bussiness_name,
    selected_project_id,
    ShowDialogTracker,
  } = ZustandStore((state) => state);

  const { t } = useTranslation();
  const { setQueryParams, removeQueryParams } = useQuery();
  const [anchorEl, setAnchorEl] = React.useState(false);

  const selectCustomDate = useSelector((state) => state.selectcustomdate);
  const oldAverageRank = useRef([]);
  const [oldAverageLabel, setOldAverageLabel] = useState([]);
  const [companyRank, setCompanyRank] = useState({
    rank: 0,
    keywords: 0,
  });
  const user_type = localStorage.getItem("user_type");
  const Is_organization = user_type === "organization";
  const [deleteAlert, setdeleteAlert] = useState(false);
  const isGuestLink = location_path.pathname === "/guest/local-tracker";

  useEffect(() => {
    ZustandStore.setState({
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
  }, []);

  const rankGroups = useMemo(() => {
    const groups = {
      top3: [],
      top10: [],
      top100: [],
      noRank: [],
    };

    RANKKEYWORD?.forEach((res) => {
      if (res.rank === "No Rank") {
        groups.noRank.push(res.rank);
      }
      if (res.rank <= 3) {
        groups.top3.push(res.rank);
      }
      if (res.rank <= 10) {
        groups.top10.push(res.rank);
      }
      if (res.rank <= 100) {
        groups.top100.push(res.rank);
      }
    });
    ZustandStore.setState({
      map_rank_group: groups,
    });
    return groups;
  }, [RANKKEYWORD]);

  const getCurrentCountryDetails = (loc) => {
    const lastString = loc.split(",").pop();
    const data = countryList?.find((item) => {
      return item.location_name == lastString;
    });
    return data?.location_flag;
  };

  const [location, setLocation] = useState("Select Location");

  useEffect(() => {
    const isoDateString = Cookies.get("TRACKING_DATE") || new Date();
    const dateToCheck = dayjs(isoDateString).format("D-MMM-YYYY");
    if (isDateDiffDaysOld(dateToCheck, 30) && !ShowDialogTracker) {
      ZustandStore.setState({
        ShowDialogTracker: true,
      });
    }
  }, []);

  const AllLocation = useMemo(() => {
    const data = map_keyword_latest_data?.map((loc) => {
      return {
        location_name: loc.LOCATION,
        location_flag: getCurrentCountryDetails(loc.LOCATION),
      };
    });
    setLocation(data?.[0]?.location_name || "Select Location");
    return data;
  }, [map_keyword_latest_data]);

  const languageHandler = useCallback((e) => {
    setLocation(e.location_name);
  }, []);

  const latestData = useMemo(() => {
    if (location === undefined || location === "Select Location") {
      const data = map_keyword_latest_data?.filter(
        (item) => item?.LOCATION == AllLocation?.[0]?.location_name
      );
      return data?.[0];
    } else {
      const data = map_keyword_latest_data?.filter(
        (item) => item?.LOCATION == location
      );
      return data?.[0];
    }
  }, [location, AllLocation]);

  const oldData = useMemo(() => {
    if (location === undefined || location === "Select Location") {
      const data = map_keyword_old_data?.filter(
        (item) => item?.LOCATION == AllLocation?.[0]?.location_name
      );
      return data?.[0];
    } else {
      const data = map_keyword_old_data?.filter(
        (item) => item?.LOCATION == location
      );
      return data?.[0];
    }
  }, [location, AllLocation]);

  const keywordData = useMemo(() => {
    return {
      keyword_latest_data: latestData?.KEYWORDDATA || [],
      keyword_old_data: oldData?.ALLOLDKEYWORDDATA || [],
    };
  }, [latestData, oldData]);

  const lastDate =
    keywordData.keyword_old_data?.length < selectCustomDate?.day
      ? keywordData.keyword_old_data?.length
      : selectCustomDate?.day;

  const keywordAverage = () => {
    const sum =
      keywordData.keyword_latest_data?.reduce((accumulator, res) => {
        if (res.rank_group !== "No Rank") {
          return accumulator + res.rank_group;
        } else {
          return accumulator + 101;
        }
      }, 0) || 0;
    setCompanyRank({
      rank: sum,
      keywords: keywordData.keyword_latest_data?.length,
    });
  };

  useEffect(() => {
    keywordAverage();
  }, [keywordData.keyword_latest_data]);

  useEffect(() => {
    setOldAverageLabel([]);
    oldAverageRank.current = []; // Clear the array
    keywordData.keyword_old_data
      ?.slice(
        keywordData.keyword_old_data?.length - lastDate,
        keywordData.keyword_old_data?.length
      )
      ?.forEach((res) => {
        let oldCompanyRankValue = 0;
        if (res?.data?.length > 0) {
          res?.data &&
            res?.data?.forEach((item) => {
              if (item?.rank_group !== "No Rank") {
                oldCompanyRankValue += item?.rank_group;
              } else {
                oldCompanyRankValue += 101;
              }
            });
          oldAverageRank.current.push(oldCompanyRankValue / res.data.length);
          setOldAverageLabel((obj) => [...obj, res.date + " " + res.month]);
        }
      });
  }, [keywordData.keyword_old_data, selectCustomDate]);

  const last_data_date = SELECTEDPROJECTNEWDATA[0]?.date
    ? SELECTEDPROJECTNEWDATA[0]?.date + " " + SELECTEDPROJECTNEWDATA[0]?.month
    : null;

  const labels = oldAverageLabel.concat(last_data_date);
  sessionStorage.setItem("rankTrackingLabel", JSON.stringify(labels));
  const todayRank = Number(companyRank?.rank) / Number(companyRank?.keywords);
  const chart_rank_data =
    companyRank?.rank >= companyRank?.keywords || todayRank > 0
      ? oldAverageRank?.current?.concat(todayRank.toFixed(1))
      : oldAverageRank?.current;
  // Filter out NaN values
  let dataData = chart_rank_data?.filter((value) => !isNaN(value));
  sessionStorage.setItem("rankTrackingData", JSON.stringify(dataData));

  let chart_data = {
    data: dataData,
    location: location,
    all_loc: AllLocation,
    labels: labels,
    loc_src: getCurrentCountryDetails(location),
  };

  const handleAddQuery = () => {
    if (isGuestLink) return;
    setQueryParams({ bussiness_name: bussiness_name });
  };

  const handleRemoveQuery = () => {
    if (isGuestLink) return;
    removeQueryParams(["domain"]);
  };

  useEffect(() => {
    if (bussiness_name) {
      handleAddQuery();
    } else {
      handleRemoveQuery();
    }
  }, [bussiness_name]);

  const lastUpdatedTime =
    SELECTEDPROJECTNEWDATA[0]?.month + " " + SELECTEDPROJECTNEWDATA[0]?.date;

  const Do_Project_Delete = (res) => {
    if (res) {
      axios.delete(MAPdelete_Project(selected_project_id)).then(() => {
        sessionStorage.removeItem("LAST_MAPPRPJECT_SELECTED");
        setdeleteAlert(false);
        ZustandStore.setState({
          map_project: [],
          bussiness_name: null,
          CURRLOCATION: {
            code: "All Locations",
            name: "All Locations",
          },
          mapshowloader: true,
          mapdeviceType: null,
          map_top_rank: {
            data: [],
            top_rank: false,
            type: "",
            competitors: false,
          },
          map_all_loc_data: [],
          map_keyword_latest_data: [],
          map_keyword_old_data: [],
          map_keyword_loc_data: "",
          selected_project_id: null,
          RANKMOVEDUP: 0,
          RANKMOVEDDOWN: 0,
          USERALLPENDINGRESULT: [],
          USERALLKEYWORDRESULT: [],
          RANKKEYWORD: [],
          SELECTEDPROJECTNEWDATA: [],
          USERCOMPATITORS: [],
          PREVIOUSALLOLDDATA: [],
          OLDKEYWORDDATA: [],
          USERCURRENTPROJECTLOCATION: [],
          tag_keywords: [],
          filter_tag: [],
          keyword_tag_data: {
            loaded: false,
            error: false,
            data: [],
          },
        });
      });
    } else {
      setdeleteAlert(false);
    }
  };

  const keywordRanking = useMemo(() => {
    return [
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.top_3"),
        value: rankGroups.top3?.length || 0,
      },
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.top_10"),
        value: rankGroups.top10?.length || 0,
      },
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.top_100"),
        value: rankGroups.top100?.length || 0,
      },
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.no_rank"),
        value: rankGroups.noRank?.length || 0,
      },
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.improved"),
        value: improved?.length || 0,
      },
      {
        name: t("rank_tracking.rank_tracker.top_rank_filter.declined"),
        value: declined?.length || 0,
      },
    ];
  }, [declined, improved, rankGroups, t]);

  return (
    <main className="rank-tracking-container main-pd dashboard-app-container">
      <section className="project-selection">
        <div className="row p-0">
          <div className="col-lg-12 col-md-12">
            <div className="project-container">
              <div className="project-header">
                <h1 className="">
                  {t("rank_tracking.map_rank_tracker.title")}
                </h1>
                {SELECTEDPROJECTNEWDATA.length > 0 ? (
                  <div className="project-last-updated">
                    {t("rank_tracking.map_rank_tracker.last_updated")}{" "}
                    <span>{lastUpdatedTime}</span>
                  </div>
                ) : null}
              </div>
              <p>{t("rank_tracking.map_rank_tracker.description")}</p>

              <div className="rank-project-sec">
                <div className="project-drop-down">
                  <div className="project-list">
                    <BusinessListDropdown />
                  </div>
                  <div className="project-location">
                    <BusinessLocation />
                  </div>
                </div>
                {location_path.pathname === "/map-tracker" ? (
                  <>
                    <AddProject />
                    <ProjectSetting />
                    <SemButton
                      title={t(
                        "rank_tracking.map_rank_tracker.guest_link_button.tooltip"
                      )}
                      name={t(
                        "rank_tracking.map_rank_tracker.guest_link_button.title"
                      )}
                      onClick={() => setAnchorEl(true)}
                    />
                    {!Is_organization && (
                      <SemButton
                        title={t(
                          "rank_tracking.map_rank_tracker.delete_project_button.tooltip"
                        )}
                        name={t(
                          "rank_tracking.map_rank_tracker.delete_project_button.title"
                        )}
                        onClick={() => setdeleteAlert(true)}
                        icon={<DeleteIcon />}
                      />
                    )}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
      <>
        {mapshowloader ? (
          <div className="rank-loader">
            <Spinner />
          </div>
        ) : (
          <>
            <section className="domian-data-card container-scroll mb-4">
              {keywordRanking?.map((item) => {
                if (item.name === "Declined" && isGuestLink) return null;
                return (
                  <div key={item.name} className="domain-card">
                    <div className="d-flex flex-column">
                      <span>{item.name}</span>
                      <span
                        className={`d-flex heading-large font-light-bold gap-2 align-items-center justify-content-center
                              ${
                                item.name === "Improved"
                                  ? "card-up"
                                  : item.name === "Declined"
                                  ? "card-down"
                                  : ""
                              }`}
                      >
                        {(item.name === "Improved" ||
                          item.name === "Declined") && <RankIcon />}
                        {item.value}
                      </span>
                    </div>
                  </div>
                );
              })}
            </section>

            <Suspense fallback={<FallbackLoader />}>
              <MapAverageRank
                chart_data={chart_data}
                handleChangeLocation={languageHandler}
              />
              <MapRankTable />
              <RankTrackingSerStop />
              <CopyLinkDialog
                {...{
                  anchorEl,
                  setAnchorEl,
                  pathname: "local-tracker",
                }}
              />
            </Suspense>
          </>
        )}
      </>
      {deleteAlert && (
        <AreYousure
          callback={Do_Project_Delete}
          title={"You will not able to recover this Project !"}
        />
      )}
    </main>
  );
};

export default MapTracking;
